import { AssigneeId } from "~/normalizr/entities";

export type ProjectMembersState = {
    projectMembers?: {
        [key: /* projectId */ string]: AssigneeId[];
    };
};

export const enum ProjectMembersActionTypes {
    SET_PROJECT_MEMBERS = "SET_PROJECT_MEMBERS",
    GET_PROJECT_MEMBERS = "GET_PROJECT_MEMBERS",
}
